import React, { useState } from 'react'
import {
  ButtonClean,
  ButtonPrimary,
  Flex,
  FormControl,
  Heading,
  Modal,
  Switch
} from 'front-end/src/components'
import { Plural, Trans } from '@lingui/macro'

export const MarkAsAcceptedModal = ({ resolve, reject, selectedInvitees }) => {
  const [sendEventRegistrationEmail, setSendEventRegistrationEmail] =
    useState(false)
  const userIdentity =
    selectedInvitees[0].email || selectedInvitees[0].account_name

  return (
    <Modal
      newDesign
      controls={
        <>
          <ButtonClean onClick={reject}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonPrimary
            onClick={() => resolve({ sendEventRegistrationEmail })}
          >
            <Trans>Mark as accepted</Trans>
          </ButtonPrimary>
        </>
      }
      onHide={reject}
    >
      <Heading mt="36px" mb="24px" size="sm">
        <Plural
          value={selectedInvitees.length}
          one={`Are you sure you want to mark ${userIdentity} as accepted?`}
          other="Are you sure you want to mark # invitees as accepted?"
        />
      </Heading>

      <FormControl
        as={Flex}
        alignItems="center"
        my="24px"
        maxW="60%"
        justifyContent="space-between"
      >
        <Trans>Send registration confirmation via email?</Trans>

        <Switch
          isChecked={sendEventRegistrationEmail}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSendEventRegistrationEmail(e.target.checked)
          }}
          dataTest="EmailResendInvitationSwitch"
        />
      </FormControl>
    </Modal>
  )
}
